<template>
  <div id="app">
    <Dropdown v-if="$route.path != '/'" />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
    <Footer />
  </div>
</template>

<script>
import Footer from "@/layout/Footer";
import Dropdown from "@/layout/Dropdown";

export default {
  name: "App",
  components: {
    Footer,
    Dropdown
  },
  created() {
    if (this.$route.path == "/" && localStorage.getItem("charlie-otr-token")) {
      this.$router.push({ name: "Emails", params: { pathName: "queue" } });
    }
    let pathAux = this.$route.path;
    let pathName = this.$route.params.pathName;
    let path = pathAux.substring(1, pathAux.length);
    if (
      pathName != "myQueue" &&
      pathName != "spanish-queue" &&
      pathName != "queue" &&
      pathName != "inProcess" &&
      pathName != "hypercubes" &&
      pathName != "alerts" &&
      pathName != "failed" &&
      pathName != "sent" &&
      pathName != "unknown" &&
      pathName != "deleted"
    ) {
      if (path != "" && path != "usersManagement") {
        this.$router.push({ name: "NotFound" });
      }
    }
  }
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $color-background-dark;
}
</style>
